var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { isBearerAuthenticator } from './bearer-authenticator.js';
import { isPasswordAuthenticator } from './password-authenticator.js';
import { isSsoAuthenticator } from './sso-authenticator.js';
import { TranslatableError } from './translation/translatable-error.js';
import { isWatAuthenticator } from './wat-authenticator.js';
function handleErrorResponse(response) {
    var _a, _b, _c;
    return __awaiter(this, void 0, void 0, function* () {
        if (!response.ok) {
            const contentType = (_a = response.headers) === null || _a === void 0 ? void 0 : _a.get('Content-Type');
            const data = contentType && contentType.includes('application/json')
                ? yield response.json().catch(() => ({}))
                : {};
            throw new TranslatableError('errors.responseError', {
                status: response.status.toString(),
                statusText: response.statusText,
                errorCode: (_b = data.error) === null || _b === void 0 ? void 0 : _b.code,
                errorMessage: (_c = data.error) === null || _c === void 0 ? void 0 : _c.message,
                context: response.statusText ? 'withStatusText' : 'onlyStatus',
            });
        }
        return response;
    });
}
function handleUnauthorizedResponse(response, auth) {
    auth.invalidate();
    // skip login redirect for token auth
    if (isPasswordAuthenticator(auth)) {
        throw new TranslatableError('errors.passwordAuthFailed');
    }
    if (isBearerAuthenticator(auth) || isWatAuthenticator(auth)) {
        throw new TranslatableError('errors.tokenAuthFailed');
    }
    if (isSsoAuthenticator(auth) && !auth.isAuthenticating()) {
        // try to reauthenticate
        void auth.authenticate();
    }
    return response;
}
/**
 * Checks if the given response error indicates a Network error.
 *
 * It is impossible to distinguish between a CORS error and other network errors, such as
 * 'net::ERR_SSL_PROTOCOL_ERROR' and 'net::ERR_EMPTY_RESPONSE'. This information is hidden by the browser.
 *
 * @param responseError - The error object received from the failed response.
 */
function isNetworkError(responseError) {
    return !!(responseError.message === 'Failed to fetch' && responseError.name === 'TypeError');
}
/**
 * Handles a Network error.
 *
 * @returns A promise that rejects with an error message.
 */
function handleNetworkError() {
    console.warn(`Network error. Verify server is accessible and your domain is added to 'CORS Allowed Origins' in Sisense Admin Panel -> Security Settings.`);
    return Promise.reject(new TranslatableError('errors.networkError'));
}
export const getResponseInterceptor = (auth) => (response) => __awaiter(void 0, void 0, void 0, function* () {
    if (response.status === 401) {
        return handleUnauthorizedResponse(response, auth);
    }
    if (!response.ok) {
        return handleErrorResponse(response);
    }
    return response;
});
export const errorInterceptor = (error) => {
    if (isNetworkError(error)) {
        return handleNetworkError();
    }
    return Promise.reject(error);
};
//# sourceMappingURL=interceptors.js.map